var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4C4 3.44772 4.44772 3 5 3H12C12.5523 3 13 3.44772 13 4C13 4.55228 12.5523 5 12 5H6V19H12C12.5523 19 13 19.4477 13 20C13 20.5523 12.5523 21 12 21H5C4.44772 21 4 20.5523 4 20V4ZM8 12C8 11.4477 8.44772 11 9 11H17.7962L15.7474 8.65852C15.3838 8.24288 15.4259 7.61112 15.8415 7.24744C16.2571 6.88375 16.8889 6.92587 17.2526 7.34151L20.7526 11.3415C21.0825 11.7185 21.0825 12.2815 20.7526 12.6585L17.2526 16.6585C16.8889 17.0742 16.2571 17.1163 15.8415 16.7526C15.4259 16.3889 15.3838 15.7571 15.7474 15.3415L17.7963 13H9C8.44772 13 8 12.5523 8 12Z",
    fill: "#1D386C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logout.7e1aa002.svg";
export { ForwardRef as ReactComponent };